var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"home-fade"}},[_c(_vm.view,{tag:"component",on:{"loaded":_vm.mainLoaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }